import React from 'react'
import queryString from 'query-string'
import NovelForm from '../NovelForm'
// import { put } from '../../../../lib/api'
import PrivatePage from '../../../../components/PrivatePage'
// import { menuItemObj } from '../../../../components/PrivatePage'

function NovelAddEdit(props) {
  const {
    location: { search },
    history,
  } = props
  const qParams = queryString.parse(search)
  const { first_publish } = qParams

  // Earlier flow was to publish chapter after novel details, which is not need now

  // const handleAfterSubmit = () => {            
  //   const { publish_chapter_id, redirect_to_home } = qParams
  //   const { id } = props.match.params
  //   if (!publish_chapter_id) {
  //     props.history.push(
  //       `${menuItemObj.novels}/id/${id}?tab=draft`
  //     );
  //     return
  //   }
  //   if (publish_chapter_id) {
  //     put('/content_api/book.update_chapter_status?is_novel=1', {
  //       data: {
  //         chapter_id: publish_chapter_id,
  //         status: 'published',
  //         book_id: id,
  //         view: 'writers',
  //       }
  //     }).then(() => {
  //       if (redirect_to_home) {
  //         history.push(menuItemObj.home)
  //       }
  //       else{
  //         props.history.push(
  //           `${menuItemObj.novels}/id/${id}?tab=draft`
  //         )
  //       }
  //     })
  //   }

  // }

  return (
    <NovelForm
      {...props}
      // afterSubmit={handleAfterSubmit}
      first_publish={first_publish}
    />
  )
}

export default function WrappedNovelAddEdit() {
  return (
    <PrivatePage>
      <NovelAddEdit />
    </PrivatePage>
  )
}
